import React, { useState } from 'react';
import { Link, Navigate, useNavigate, useSearchParams } from 'react-router-dom';
import { useStudentAuth } from '../../contexts/StudentAuthContext';

export default function StudentLogin() {
  const { student, loading, signIn } = useStudentAuth();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [email, setEmail] = useState(params.get('email') || '');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  if (!loading && student) {
    return <Navigate to="/student/dashboard" replace />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);
    try {
      await signIn(email, password);
      navigate('/student/dashboard', { replace: true });
    } catch (err) {
      setError(err.message || 'Sign in failed');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-stone-50 px-6">
      <form
        onSubmit={handleSubmit}
        className="max-w-md w-full rounded-2xl border border-stone-200 bg-white p-8 space-y-4"
      >
        <div>
          <p className="text-xs uppercase tracking-widest text-stone-500 mb-1">Prosperity Mentors</p>
          <h1 className="text-2xl font-semibold text-stone-900">Student sign in</h1>
        </div>
        {error && <p className="text-sm text-red-600">{error}</p>}
        <input
          required
          type="email"
          className="w-full h-11 rounded-lg border border-stone-300 px-3 text-sm"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <input
          required
          type="password"
          className="w-full h-11 rounded-lg border border-stone-300 px-3 text-sm"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button
          type="submit"
          disabled={submitting}
          className="w-full h-11 rounded-lg bg-amber-800 text-white text-sm font-medium hover:bg-amber-700 disabled:opacity-60"
        >
          {submitting ? 'Signing in…' : 'Sign in'}
        </button>
        <p className="text-center text-xs text-stone-500">
          New here? Use the link from your registration email to create an account.
        </p>
        <p className="text-center text-sm">
          <Link to="/student/claim" className="text-amber-800 hover:underline">Have a claim link?</Link>
        </p>
      </form>
    </div>
  );
}
